// Translations for Parking Plot Escape.
// Keys are grouped by namespace. Missing keys fall back to English.

export const LOCALES = [
  { code: "en", label: "EN", name: "English", dir: "ltr" },
  { code: "fr", label: "FR", name: "Français", dir: "ltr" },
  { code: "es", label: "ES", name: "Español", dir: "ltr" },
  { code: "ar", label: "ع", name: "العربية", dir: "rtl" },
  { code: "zh", label: "中", name: "中文", dir: "ltr" },
  { code: "ru", label: "RU", name: "Русский", dir: "ltr" },
];

const en = {
  menu: {
    banner: "NEON // ARCADE // 2026",
    protocol: "PROTOCOL: ESCAPE",
    title1: "PARKING",
    title2: "PLOT",
    title3: "ESCAPE.",
    tagline:
      "You are on foot. They are not. Weave through parked cars, dodge relentless hunters, grab power-ups and reach the neon-green exit before they flatten you. Two lots. One rule: keep moving.",
    mode: "MODE",
    mode_2d: "2D · TOP-DOWN",
    mode_3d: "3D · CHASE-CAM",
    play_outdoor: "PLAY · OUTDOOR",
    play_underground: "PLAY · UNDERGROUND",
    play_daily: "DAILY CHALLENGE",
    daily_sub: "SAME MAP · GLOBAL · FREE FOR ALL",
    play_rooftop: "PLAY · ROOFTOP",
    rooftop_sub: "TWO EXITS · GUSTY WIND · SUNSET",
    play_highway: "PLAY · HIGHWAY",
    highway_sub: "6 LANES · CROSS THE TRAFFIC · NIGHT",
    play_snowstorm: "PLAY · SNOWSTORM",
    snowstorm_sub: "SLIPPERY ICE · WHITEOUT · 2 EXITS",
    play_tunnels: "PLAY · TUNNELS",
    tunnels_sub: "NARROW MAZE · 2 EXITS · TIGHT CORNERS",
    play_beach: "PLAY · BEACH",
    beach_sub: "SAND FRICTION · PALM TREES · GOLDEN HOUR",
    weather: "WEATHER",
    weather_toast: "WEATHER",
    roulette: "ROULETTE",
    handle: "HANDLE",
    play_neon_rain: "PLAY · NEON RAIN",
    neon_rain_sub: "WET NEON NIGHT · 2 EXITS · SEASON PASS EXCLUSIVE",
    achievements: "ACHIEVEMENTS",
    reminder_on: "DAILY REMINDER · ON",
    reminder_off: "REMIND ME EACH DAY",
    push_on: "PUSH ALERTS · ON",
    push_off: "PUSH ALERTS · OFF",
    push_on_toast: "Push notifications ON.",
    push_off_toast: "Push notifications OFF.",
    push_denied_toast: "Notifications blocked — enable them in your browser.",
    push_error_toast: "Could not enable push notifications.",
    get_season: "SEASON PASS",
    season_badge: "SEASON",
    season_active: "Season Pass active",
    season_monthly_label: "MONTHLY",
    season_expired: "EXPIRED",
    h_short: "h",
    d_short: "d",
    daily_at_risk: "STREAK AT RISK · PLAY TODAY TO KEEP IT",
    outdoor_sub: "TWO EXITS · MEDIUM",
    underground_sub: "ONE EXIT · HARD",
    pro_tag: "PRO",
    unlock_hint: "$1.99 UNLOCKS EVERYTHING TODAY",
    season_track: "SEASON TRACK",
    shop: "SHOP",
    leaderboard: "LEADERBOARD",
    how_to_play: "HOW TO PLAY",
    local_records: "LOCAL RECORDS",
    outdoor: "OUTDOOR",
    underground: "UNDERGROUND",
    power_ups: "POWER-UPS",
    controls: "CONTROLS",
    move: "MOVE",
    pause: "PAUSE",
    objective: "OBJECTIVE",
    reach_exit: "REACH EXIT",
    keys_move: "WASD / ARROWS",
    key_pause: "ESC",
    footer: "// KEEP MOVING · TIME IS SCORE",
    upgrade_pro: "UPGRADE TO PRO",
    pro_badge: "PRO",
  },
  powerups: {
    shield: "SHIELD",
    shield_desc: "5s invincibility to enemy cars.",
    boost: "BOOST",
    boost_desc: "4s sprint. Make a break for it.",
    freeze: "FREEZE",
    freeze_desc: "3s. Enemies stop dead.",
  },
  hud: {
    score: "SCORE",
    time: "TIME",
    stage: "STAGE",
    hi: "HI",
    lives: "LIVES",
    pause: "PAUSE",
    resume: "RESUME",
    quit: "QUIT",
    paused: "PAUSED",
    press_esc: "PRESS ESC OR RESUME TO CONTINUE",
    difficulty_up: "DIFFICULTY UP",
    stage_desc: "FASTER · MORE HUNTERS · +BONUS",
    controls_hint: "WASD · ARROWS to move · ESC to pause · REACH THE",
    green_exit: "GREEN EXIT",
  },
  howto: {
    title: "HOW TO PLAY",
    subtitle: "Escape the parking plot. Don't become roadkill.",
    move: "MOVE",
    move_v: "WASD or ARROW keys",
    pause: "PAUSE",
    pause_v: "ESC",
    goal: "GOAL",
    goal_v: "Reach a glowing GREEN exit",
    avoid: "AVOID",
    avoid_v: "RED cars — they chase you",
    collect: "COLLECT",
    collect_v: "Pulsing YELLOW power-ups",
    footer:
      "Underground mode has only ONE exit and faster hunters. Time and lives count as score bonus at the exit.",
  },
  gameover: {
    escaped: "YOU ESCAPED.",
    flattened: "FLATTENED.",
    level: "LEVEL",
    time: "TIME",
    score: "SCORE",
    new_high: "NEW LOCAL HIGH SCORE",
    submit_board: "SUBMIT TO GLOBAL BOARD",
    callsign_ph: "CALLSIGN",
    send: "SEND",
    unlock: "UNLOCK",
    submitted: "✓ SUBMITTED",
    retry: "RETRY",
    menu: "MENU",
    board: "BOARD",
    toast_name_missing: "Enter a callsign to submit.",
    toast_submitted: "Score submitted to the neon board.",
    toast_submit_failed: "Could not submit score. Try again.",
  },
  paywall: {
    tag: "PARKING PLOT ESCAPE · PRO",
    title_lead: "Unlock",
    title_accent: "everything.",
    subtitle: "is a Pro feature. Upgrade once, escape forever.",
    default_feature: "This feature",
    feature_3d_underground: "3D + Underground",
    feature_3d: "3D chase-cam mode",
    feature_underground: "The Underground garage",
    feature_rooftop: "The Rooftop stage",
    feature_highway: "The Highway stage",
    feature_snowstorm: "The Snowstorm stage",
    feature_tunnels: "The Tunnels stage",
    feature_beach: "The Beach stage",
    feature_neon_rain: "The Neon Rain bonus stage",
    feature_season: "Season Pass perks",
    feature_full: "the full experience",
    feature_leaderboard: "Global leaderboard submission",
    bullet_3d: "3D chase-cam mode + Underground garage",
    bullet_stages: "Unlimited stages (Free is capped at Stage 3)",
    bullet_powerups: "All 3 power-ups: Shield · Boost · Freeze",
    bullet_leaderboard: "Submit scores to the global leaderboard",
    tab_pro: "PRO",
    tab_season: "SEASON PASS",
    season_tag: "LIMITED SEASON",
    season_title_lead: "UNLEASH",
    season_title_accent: "THE SEASON",
    season_subtitle: "Time-limited perks that stack with Pro.",
    season_perk_life: "+1 starting life every run",
    season_perk_xp: "2× score & XP multiplier",
    season_perk_level: "Bonus level · Neon Rain",
    season_perk_skin: "Exclusive Season Champion skin",
    season_perk_pro: "Includes all Pro levels while active",
    season_daily: "24-HOUR PASS",
    season_daily_sub: "ONE DAY OF PERKS",
    season_monthly: "SEASON MONTHLY",
    season_monthly_sub: "PERKS ACTIVE AS LONG AS YOU RENEW",
    season_30day: "30-DAY PASS",
    season_30day_sub: "ONE-TIME · 30 DAYS OF PERKS",
    best_value: "BEST VALUE",
    test_mode: "TEST MODE · use card",
    test_card_hint: "· any future expiry · any CVC",
    email_label: "EMAIL",
    email_ph: "you@escape.com",
    email_help: "Pro follows this email on any device.",
    lifetime: "LIFETIME",
    lifetime_sub: "one-time · best value",
    monthly: "MONTHLY",
    monthly_sub: "cancel anytime",
    per_month: "/mo",
    restore_toggle: "ALREADY PURCHASED? RESTORE →",
    restore_hint: "Enter the email you used at checkout to restore your Pro on this device.",
    restore_button: "RESTORE PRO",
    back_purchase: "← BACK TO PURCHASE",
    toast_invalid_email: "Please enter a valid email first.",
    toast_purchase_email: "Please enter your purchase email.",
    toast_checkout_failed: "Could not start checkout. Try again.",
    toast_no_pro_found: "No Pro purchase found for this email.",
    toast_pro_unlocked: "Pro unlocked on this device.",
    coupon_label: "COUPON",
    coupon_ph: "PROMO25",
    coupon_apply: "APPLY",
    coupon_applied: "{code} applied",
    coupon_not_found: "Coupon not found",
    coupon_invalid: "Invalid coupon",
  },
  leaderboard: {
    back: "BACK",
    header: "HALL OF SURVIVORS",
    title_lead: "LEADER",
    title_accent: "BOARD",
    tab_outdoor: "OUTDOOR",
    tab_underground: "UNDERGROUND",
    tab_daily: "DAILY",
    tab_weekly: "WEEKLY",
    watch_ghost: "WATCH GHOST",
    hall_of_champions: "HALL OF CHAMPIONS",
    col_rank: "#",
    col_name: "CALLSIGN",
    col_time: "TIME",
    col_score: "SCORE",
    loading: "LOADING...",
    empty: "NO RUNS YET · BE FIRST",
  },
  payment: {
    finalizing: "FINALIZING",
    confirming: "CONFIRMING YOUR PAYMENT…",
    welcome_pro: "WELCOME TO PRO",
    welcome_desc:
      "Everything is unlocked. 3D · Underground · Unlimited stages · All power-ups · Global board.",
    start_escaping: "START ESCAPING →",
    not_confirmed: "PAYMENT NOT CONFIRMED",
    not_confirmed_desc:
      "We couldn't confirm the charge. If you were charged, use \"Restore\" from the paywall with your purchase email.",
    back_menu: "← BACK TO MENU",
    canceled: "CHECKOUT CANCELED",
    canceled_desc: "No charge was made. You can upgrade anytime.",
  },
  common: {
    language: "LANGUAGE",
  },
};

const fr = {
  menu: {
    banner: "NÉON // ARCADE // 2026",
    protocol: "PROTOCOLE : ÉVASION",
    title1: "PARKING",
    title2: "PLOT",
    title3: "ÉVASION.",
    tagline:
      "Vous êtes à pied. Eux, non. Faufilez-vous entre les voitures garées, esquivez les chasseurs implacables, ramassez des bonus et atteignez la sortie vert-néon avant qu'ils ne vous écrasent. Deux parkings. Une règle : ne vous arrêtez jamais.",
    mode: "MODE",
    mode_2d: "2D · VUE DE HAUT",
    mode_3d: "3D · CAMÉRA POURSUITE",
    play_outdoor: "JOUER · EXTÉRIEUR",
    play_underground: "JOUER · SOUS-SOL",
    play_daily: "DÉFI QUOTIDIEN",
    daily_sub: "MÊME CARTE · MONDIAL · GRATUIT POUR TOUS",
    play_rooftop: "JOUER · TOIT",
    rooftop_sub: "DEUX SORTIES · VENT · COUCHER DU SOLEIL",
    play_highway: "JOUER · AUTOROUTE",
    highway_sub: "6 VOIES · TRAVERSER · NUIT",
    play_snowstorm: "JOUER · TEMPÊTE DE NEIGE",
    snowstorm_sub: "GLACE GLISSANTE · BLANCHEUR · 2 SORTIES",
    play_tunnels: "JOUER · TUNNELS",
    tunnels_sub: "LABYRINTHE ÉTROIT · 2 SORTIES · VIRAGES SERRÉS",
    play_neon_rain: "JOUER · PLUIE NÉON",
    neon_rain_sub: "NUIT NÉON MOUILLÉE · 2 SORTIES · PASS EXCLUSIF",
    push_on: "ALERTES · ACTIVÉES",
    push_off: "ALERTES · DÉSACTIVÉES",
    get_season: "PASS SAISON",
    season_badge: "SAISON",
    season_monthly_label: "MENSUEL",
    achievements: "SUCCÈS",
    reminder_on: "RAPPEL QUOTIDIEN · ON",
    reminder_off: "ME RAPPELER CHAQUE JOUR",
    daily_at_risk: "SÉRIE EN DANGER · JOUE AUJOURD'HUI",
    outdoor_sub: "DEUX SORTIES · MOYEN",
    underground_sub: "UNE SORTIE · DIFFICILE",
    pro_tag: "PRO",
    leaderboard: "CLASSEMENT",
    how_to_play: "COMMENT JOUER",
    local_records: "RECORDS LOCAUX",
    outdoor: "EXTÉRIEUR",
    underground: "SOUS-SOL",
    power_ups: "BONUS",
    controls: "COMMANDES",
    move: "SE DÉPLACER",
    pause: "PAUSE",
    objective: "OBJECTIF",
    reach_exit: "ATTEINDRE LA SORTIE",
    keys_move: "ZQSD / FLÈCHES",
    key_pause: "ÉCHAP",
    footer: "// NE VOUS ARRÊTEZ PAS · LE TEMPS EST SCORE",
    upgrade_pro: "PASSER À PRO",
    pro_badge: "PRO",
  },
  powerups: {
    shield: "BOUCLIER",
    shield_desc: "Invincibilité de 5 s contre les voitures.",
    boost: "TURBO",
    boost_desc: "Sprint de 4 s. Foncez !",
    freeze: "GEL",
    freeze_desc: "3 s. Les ennemis s'immobilisent.",
  },
  hud: {
    score: "SCORE",
    time: "TEMPS",
    stage: "NIVEAU",
    hi: "REC",
    lives: "VIES",
    pause: "PAUSE",
    resume: "REPRENDRE",
    quit: "QUITTER",
    paused: "EN PAUSE",
    press_esc: "APPUYEZ SUR ÉCHAP OU REPRENDRE",
    difficulty_up: "DIFFICULTÉ AUGMENTÉE",
    stage_desc: "PLUS RAPIDE · PLUS DE CHASSEURS · +BONUS",
    controls_hint: "ZQSD · FLÈCHES pour bouger · ÉCHAP pour pause · REJOIGNEZ LA",
    green_exit: "SORTIE VERTE",
  },
  howto: {
    title: "COMMENT JOUER",
    subtitle: "Fuyez le parking. Ne finissez pas en carpette.",
    move: "SE DÉPLACER",
    move_v: "ZQSD ou touches FLÈCHES",
    pause: "PAUSE",
    pause_v: "ÉCHAP",
    goal: "OBJECTIF",
    goal_v: "Atteindre une sortie VERTE lumineuse",
    avoid: "ÉVITER",
    avoid_v: "Les voitures ROUGES — elles vous chassent",
    collect: "RAMASSER",
    collect_v: "Bonus JAUNES pulsants",
    footer:
      "Le mode Sous-sol n'a qu'UNE seule sortie et des chasseurs plus rapides. Le temps et les vies restantes rapportent un bonus à la sortie.",
  },
  gameover: {
    escaped: "VOUS VOUS ÊTES ÉVADÉ.",
    flattened: "APLATI.",
    level: "NIVEAU",
    time: "TEMPS",
    score: "SCORE",
    new_high: "NOUVEAU RECORD LOCAL",
    submit_board: "ENVOYER AU CLASSEMENT GLOBAL",
    callsign_ph: "PSEUDO",
    send: "ENVOYER",
    unlock: "DÉBLOQUER",
    submitted: "✓ ENVOYÉ",
    retry: "REJOUER",
    menu: "MENU",
    board: "TABLEAU",
    toast_name_missing: "Entrez un pseudo pour envoyer.",
    toast_submitted: "Score envoyé au tableau néon.",
    toast_submit_failed: "Impossible d'envoyer le score. Réessayez.",
  },
  paywall: {
    tag: "PARKING PLOT ESCAPE · PRO",
    title_lead: "Débloquez",
    title_accent: "tout.",
    subtitle: "est une fonctionnalité Pro. Achetez une fois, évadez-vous à vie.",
    default_feature: "Cette fonctionnalité",
    feature_3d_underground: "3D + Sous-sol",
    feature_3d: "Mode caméra poursuite 3D",
    feature_underground: "Le parking sous-sol",
    feature_rooftop: "Le niveau du toit",
    feature_highway: "Le niveau autoroute",
    feature_snowstorm: "Le niveau tempête de neige",
    feature_tunnels: "Le niveau tunnels",
    feature_full: "l'expérience complète",
    feature_leaderboard: "L'envoi au classement global",
    bullet_3d: "Mode 3D caméra poursuite + parking sous-sol",
    bullet_stages: "Niveaux illimités (gratuit plafonné au niveau 3)",
    bullet_powerups: "Les 3 bonus : Bouclier · Turbo · Gel",
    bullet_leaderboard: "Envoyer vos scores au classement global",
    test_mode: "MODE TEST · utilisez la carte",
    test_card_hint: "· expiration future · CVC libre",
    email_label: "E-MAIL",
    email_ph: "vous@escape.com",
    email_help: "Le Pro suit cet e-mail sur n'importe quel appareil.",
    lifetime: "À VIE",
    lifetime_sub: "unique · meilleure valeur",
    monthly: "MENSUEL",
    monthly_sub: "annulez à tout moment",
    per_month: "/mois",
    restore_toggle: "DÉJÀ ACHETÉ ? RESTAURER →",
    restore_hint:
      "Entrez l'e-mail utilisé au paiement pour restaurer votre Pro sur cet appareil.",
    restore_button: "RESTAURER PRO",
    back_purchase: "← RETOUR À L'ACHAT",
    toast_invalid_email: "Veuillez saisir un e-mail valide.",
    toast_purchase_email: "Veuillez saisir votre e-mail d'achat.",
    toast_checkout_failed: "Impossible de lancer le paiement. Réessayez.",
    toast_no_pro_found: "Aucun achat Pro trouvé pour cet e-mail.",
    toast_pro_unlocked: "Pro débloqué sur cet appareil.",
  },
  leaderboard: {
    back: "RETOUR",
    header: "SALLE DES SURVIVANTS",
    title_lead: "CLASSE",
    title_accent: "MENT",
    tab_outdoor: "EXTÉRIEUR",
    tab_underground: "SOUS-SOL",
    tab_daily: "QUOTIDIEN",
    tab_weekly: "HEBDO",
    watch_ghost: "VOIR FANTÔME",
    hall_of_champions: "SALLE DES CHAMPIONS",
    col_rank: "#",
    col_name: "PSEUDO",
    col_time: "TEMPS",
    col_score: "SCORE",
    loading: "CHARGEMENT...",
    empty: "AUCUNE COURSE · SOYEZ LE PREMIER",
  },
  payment: {
    finalizing: "FINALISATION",
    confirming: "CONFIRMATION DU PAIEMENT…",
    welcome_pro: "BIENVENUE DANS PRO",
    welcome_desc:
      "Tout est débloqué. 3D · Sous-sol · Niveaux illimités · Tous les bonus · Classement global.",
    start_escaping: "COMMENCER À FUIR →",
    not_confirmed: "PAIEMENT NON CONFIRMÉ",
    not_confirmed_desc:
      "Impossible de confirmer le paiement. Si vous avez été débité, utilisez « Restaurer » avec votre e-mail d'achat.",
    back_menu: "← RETOUR AU MENU",
    canceled: "PAIEMENT ANNULÉ",
    canceled_desc: "Aucun débit n'a été effectué. Vous pouvez passer à Pro à tout moment.",
  },
  common: {
    language: "LANGUE",
  },
};

const es = {
  menu: {
    banner: "NEÓN // ARCADE // 2026",
    protocol: "PROTOCOLO: ESCAPE",
    title1: "PARKING",
    title2: "PLOT",
    title3: "ESCAPE.",
    tagline:
      "Vas a pie. Ellos no. Esquiva coches aparcados, escapa de cazadores implacables, recoge potenciadores y llega a la salida verde neón antes de que te aplasten. Dos aparcamientos. Una regla: no pares.",
    mode: "MODO",
    mode_2d: "2D · VISTA CENITAL",
    mode_3d: "3D · CÁMARA PERSECUCIÓN",
    play_outdoor: "JUGAR · EXTERIOR",
    play_underground: "JUGAR · SUBTERRÁNEO",
    play_daily: "DESAFÍO DIARIO",
    daily_sub: "MISMO MAPA · GLOBAL · GRATIS PARA TODOS",
    play_rooftop: "JUGAR · AZOTEA",
    rooftop_sub: "DOS SALIDAS · VIENTO · ATARDECER",
    play_highway: "JUGAR · AUTOPISTA",
    highway_sub: "6 CARRILES · CRUZA EL TRÁFICO · NOCHE",
    play_snowstorm: "JUGAR · NEVASCA",
    snowstorm_sub: "HIELO RESBALADIZO · BLANCURA · 2 SALIDAS",
    play_tunnels: "JUGAR · TÚNELES",
    tunnels_sub: "LABERINTO ESTRECHO · 2 SALIDAS · CURVAS CERRADAS",
    play_neon_rain: "JUGAR · LLUVIA NEÓN",
    neon_rain_sub: "NOCHE NEÓN MOJADA · 2 SALIDAS · EXCLUSIVO PASE",
    push_on: "AVISOS · ACTIVOS",
    push_off: "AVISOS · INACTIVOS",
    get_season: "PASE DE TEMPORADA",
    season_badge: "TEMPORADA",
    season_monthly_label: "MENSUAL",
    achievements: "LOGROS",
    reminder_on: "RECORDATORIO DIARIO · ON",
    reminder_off: "RECORDÁRMELO CADA DÍA",
    daily_at_risk: "RACHA EN RIESGO · JUEGA HOY",
    outdoor_sub: "DOS SALIDAS · MEDIO",
    underground_sub: "UNA SALIDA · DIFÍCIL",
    pro_tag: "PRO",
    leaderboard: "CLASIFICACIÓN",
    how_to_play: "CÓMO JUGAR",
    local_records: "RÉCORDS LOCALES",
    outdoor: "EXTERIOR",
    underground: "SUBTERRÁNEO",
    power_ups: "POTENCIADORES",
    controls: "CONTROLES",
    move: "MOVER",
    pause: "PAUSA",
    objective: "OBJETIVO",
    reach_exit: "ALCANZAR LA SALIDA",
    keys_move: "WASD / FLECHAS",
    key_pause: "ESC",
    footer: "// SIGUE MOVIÉNDOTE · EL TIEMPO ES PUNTOS",
    upgrade_pro: "PASAR A PRO",
    pro_badge: "PRO",
  },
  powerups: {
    shield: "ESCUDO",
    shield_desc: "Invencibilidad de 5s ante los coches.",
    boost: "TURBO",
    boost_desc: "Sprint de 4s. ¡A por la salida!",
    freeze: "CONGELAR",
    freeze_desc: "3s. Los enemigos se detienen.",
  },
  hud: {
    score: "PUNTOS",
    time: "TIEMPO",
    stage: "NIVEL",
    hi: "REC",
    lives: "VIDAS",
    pause: "PAUSA",
    resume: "REANUDAR",
    quit: "SALIR",
    paused: "EN PAUSA",
    press_esc: "PULSA ESC O REANUDAR PARA CONTINUAR",
    difficulty_up: "DIFICULTAD AL ALZA",
    stage_desc: "MÁS RÁPIDO · MÁS CAZADORES · +BONUS",
    controls_hint: "WASD · FLECHAS para mover · ESC para pausar · ALCANZA LA",
    green_exit: "SALIDA VERDE",
  },
  howto: {
    title: "CÓMO JUGAR",
    subtitle: "Huye del aparcamiento. No acabes como atropello.",
    move: "MOVER",
    move_v: "WASD o teclas de FLECHA",
    pause: "PAUSA",
    pause_v: "ESC",
    goal: "META",
    goal_v: "Alcanzar una salida VERDE brillante",
    avoid: "EVITAR",
    avoid_v: "Coches ROJOS — te persiguen",
    collect: "RECOGER",
    collect_v: "Potenciadores AMARILLOS pulsantes",
    footer:
      "El modo Subterráneo tiene solo UNA salida y cazadores más rápidos. El tiempo y las vidas suman bonus al salir.",
  },
  gameover: {
    escaped: "HAS ESCAPADO.",
    flattened: "APLASTADO.",
    level: "NIVEL",
    time: "TIEMPO",
    score: "PUNTOS",
    new_high: "NUEVO RÉCORD LOCAL",
    submit_board: "ENVIAR AL RANKING GLOBAL",
    callsign_ph: "ALIAS",
    send: "ENVIAR",
    unlock: "DESBLOQUEAR",
    submitted: "✓ ENVIADO",
    retry: "REINTENTAR",
    menu: "MENÚ",
    board: "RANKING",
    toast_name_missing: "Introduce un alias para enviar.",
    toast_submitted: "Puntuación enviada al tablero neón.",
    toast_submit_failed: "No se pudo enviar la puntuación. Reintenta.",
  },
  paywall: {
    tag: "PARKING PLOT ESCAPE · PRO",
    title_lead: "Desbloquea",
    title_accent: "todo.",
    subtitle: "es una función Pro. Compra una vez, escapa para siempre.",
    default_feature: "Esta función",
    feature_3d_underground: "3D + Subterráneo",
    feature_3d: "Modo cámara persecución 3D",
    feature_underground: "El garaje subterráneo",
    feature_rooftop: "El escenario de azotea",
    feature_highway: "El escenario de autopista",
    feature_snowstorm: "El escenario de nevasca",
    feature_tunnels: "El escenario de túneles",
    feature_full: "la experiencia completa",
    feature_leaderboard: "Envío al ranking global",
    bullet_3d: "Modo 3D con cámara + garaje subterráneo",
    bullet_stages: "Niveles ilimitados (gratis se detiene en el nivel 3)",
    bullet_powerups: "Los 3 potenciadores: Escudo · Turbo · Congelar",
    bullet_leaderboard: "Envía tus puntuaciones al ranking global",
    test_mode: "MODO PRUEBA · usa la tarjeta",
    test_card_hint: "· cualquier fecha futura · cualquier CVC",
    email_label: "CORREO",
    email_ph: "tu@escape.com",
    email_help: "Pro sigue este correo en cualquier dispositivo.",
    lifetime: "DE POR VIDA",
    lifetime_sub: "único pago · mejor valor",
    monthly: "MENSUAL",
    monthly_sub: "cancela cuando quieras",
    per_month: "/mes",
    restore_toggle: "¿YA COMPRASTE? RESTAURAR →",
    restore_hint:
      "Introduce el correo usado al pagar para restaurar tu Pro en este dispositivo.",
    restore_button: "RESTAURAR PRO",
    back_purchase: "← VOLVER A COMPRAR",
    toast_invalid_email: "Introduce un correo válido.",
    toast_purchase_email: "Introduce tu correo de compra.",
    toast_checkout_failed: "No se pudo iniciar el pago. Reintenta.",
    toast_no_pro_found: "No se encontró compra Pro para este correo.",
    toast_pro_unlocked: "Pro desbloqueado en este dispositivo.",
  },
  leaderboard: {
    back: "VOLVER",
    header: "SALÓN DE SUPERVIVIENTES",
    title_lead: "RAN",
    title_accent: "KING",
    tab_outdoor: "EXTERIOR",
    tab_underground: "SUBTERRÁNEO",
    tab_daily: "DIARIO",
    tab_weekly: "SEMANAL",
    watch_ghost: "VER FANTASMA",
    hall_of_champions: "SALA DE CAMPEONES",
    col_rank: "#",
    col_name: "ALIAS",
    col_time: "TIEMPO",
    col_score: "PUNTOS",
    loading: "CARGANDO...",
    empty: "SIN PARTIDAS · SÉ EL PRIMERO",
  },
  payment: {
    finalizing: "FINALIZANDO",
    confirming: "CONFIRMANDO TU PAGO…",
    welcome_pro: "BIENVENIDO A PRO",
    welcome_desc:
      "Todo desbloqueado. 3D · Subterráneo · Niveles ilimitados · Todos los potenciadores · Ranking global.",
    start_escaping: "EMPEZAR A ESCAPAR →",
    not_confirmed: "PAGO NO CONFIRMADO",
    not_confirmed_desc:
      "No pudimos confirmar el cargo. Si te cobraron, usa \"Restaurar\" en la paywall con tu correo de compra.",
    back_menu: "← VOLVER AL MENÚ",
    canceled: "PAGO CANCELADO",
    canceled_desc: "No se realizó ningún cargo. Puedes pasar a Pro cuando quieras.",
  },
  common: {
    language: "IDIOMA",
  },
};

const ar = {
  menu: {
    banner: "نيون // آركيد // 2026",
    protocol: "بروتوكول: الهروب",
    title1: "موقف",
    title2: "السيارات",
    title3: ".الهروب",
    tagline:
      "أنت راجل. هم لا. تسلّل بين السيارات المصفوفة، وتفادى المطاردين الأشرار، والتقط التعزيزات، واصل إلى المخرج الأخضر النيوني قبل أن يسحقوك. موقفان، وقاعدة واحدة: لا تتوقف.",
    mode: "الوضع",
    mode_2d: "ثنائي · من الأعلى",
    mode_3d: "ثلاثي · كاميرا المطاردة",
    play_outdoor: "العب · الخارجي",
    play_underground: "العب · تحت الأرض",
    play_daily: "التحدي اليومي",
    daily_sub: "نفس الخريطة · عالمي · مجاناً للجميع",
    play_rooftop: "العب · السطح",
    rooftop_sub: "مخرجان · رياح · غروب",
    play_highway: "العب · الطريق السريع",
    highway_sub: "6 حارات · اعبر الحركة · ليلاً",
    play_snowstorm: "العب · عاصفة ثلجية",
    snowstorm_sub: "جليد زلق · بياض · مخرجان",
    play_tunnels: "العب · الأنفاق",
    tunnels_sub: "متاهة ضيقة · مخرجان · منعطفات حادة",
    play_neon_rain: "العب · مطر النيون",
    neon_rain_sub: "ليلة نيون مبللة · مخرجان · حصري لتذكرة الموسم",
    push_on: "الإشعارات · مفعّلة",
    push_off: "الإشعارات · معطّلة",
    get_season: "تذكرة الموسم",
    season_badge: "الموسم",
    season_monthly_label: "شهري",
    achievements: "الإنجازات",
    reminder_on: "تذكير يومي · تشغيل",
    reminder_off: "ذكّرني يومياً",
    daily_at_risk: "السلسلة في خطر · العب اليوم",
    outdoor_sub: "مخرجان · متوسط",
    underground_sub: "مخرج واحد · صعب",
    pro_tag: "برو",
    leaderboard: "لوحة الصدارة",
    how_to_play: "كيفية اللعب",
    local_records: "الأرقام القياسية المحلية",
    outdoor: "الخارجي",
    underground: "تحت الأرض",
    power_ups: "التعزيزات",
    controls: "التحكم",
    move: "التحرك",
    pause: "إيقاف مؤقت",
    objective: "الهدف",
    reach_exit: "الوصول إلى المخرج",
    keys_move: "WASD / الأسهم",
    key_pause: "ESC",
    footer: "// استمر في الحركة · الوقت هو النقاط",
    upgrade_pro: "الترقية إلى برو",
    pro_badge: "برو",
  },
  powerups: {
    shield: "درع",
    shield_desc: "مناعة لمدة 5 ثوانٍ ضد السيارات.",
    boost: "تسريع",
    boost_desc: "اندفاعة 4 ثوانٍ. اهرب!",
    freeze: "تجميد",
    freeze_desc: "3 ثوانٍ. الأعداء يتوقفون.",
  },
  hud: {
    score: "النقاط",
    time: "الوقت",
    stage: "المرحلة",
    hi: "أفضل",
    lives: "الأرواح",
    pause: "إيقاف",
    resume: "متابعة",
    quit: "خروج",
    paused: "متوقف مؤقتاً",
    press_esc: "اضغط ESC أو متابعة للاستمرار",
    difficulty_up: "ارتفاع الصعوبة",
    stage_desc: "أسرع · مطاردون أكثر · +مكافأة",
    controls_hint: "WASD · الأسهم للتحرك · ESC للإيقاف · اصل إلى",
    green_exit: "المخرج الأخضر",
  },
  howto: {
    title: "كيفية اللعب",
    subtitle: "اهرب من الموقف. لا تصبح مسحوقاً.",
    move: "التحرك",
    move_v: "WASD أو مفاتيح الأسهم",
    pause: "إيقاف",
    pause_v: "ESC",
    goal: "الهدف",
    goal_v: "الوصول إلى مخرج أخضر متوهج",
    avoid: "تجنب",
    avoid_v: "السيارات الحمراء — إنها تطاردك",
    collect: "التقط",
    collect_v: "التعزيزات الصفراء النابضة",
    footer:
      "وضع تحت الأرض يحتوي على مخرج واحد فقط ومطاردين أسرع. الوقت والأرواح تعتبر مكافأة عند المخرج.",
  },
  gameover: {
    escaped: ".لقد هربت",
    flattened: ".لقد سُحقت",
    level: "المستوى",
    time: "الوقت",
    score: "النقاط",
    new_high: "رقم قياسي محلي جديد",
    submit_board: "الإرسال إلى اللوحة العالمية",
    callsign_ph: "الاسم الرمزي",
    send: "إرسال",
    unlock: "فتح",
    submitted: "✓ تم الإرسال",
    retry: "إعادة",
    menu: "القائمة",
    board: "اللوحة",
    toast_name_missing: "أدخل اسماً رمزياً للإرسال.",
    toast_submitted: "تم إرسال النتيجة إلى اللوحة النيونية.",
    toast_submit_failed: "تعذر إرسال النتيجة. حاول مرة أخرى.",
  },
  paywall: {
    tag: "بروتوكول الهروب · برو",
    title_lead: "افتح",
    title_accent: ".كل شيء",
    subtitle: "ميزة برو. اشترِ مرة واحدة، اهرب إلى الأبد.",
    default_feature: "هذه الميزة",
    feature_3d_underground: "الثلاثي + تحت الأرض",
    feature_3d: "وضع الكاميرا الثلاثي",
    feature_underground: "الموقف تحت الأرض",
    feature_rooftop: "مرحلة السطح",
    feature_highway: "مرحلة الطريق السريع",
    feature_snowstorm: "مرحلة العاصفة الثلجية",
    feature_tunnels: "مرحلة الأنفاق",
    feature_full: "التجربة الكاملة",
    feature_leaderboard: "الإرسال إلى اللوحة العالمية",
    bullet_3d: "وضع الكاميرا الثلاثي + الموقف تحت الأرض",
    bullet_stages: "مراحل لا محدودة (المجاني محدود بالمرحلة 3)",
    bullet_powerups: "جميع التعزيزات الثلاثة: درع · تسريع · تجميد",
    bullet_leaderboard: "أرسل نتائجك إلى اللوحة العالمية",
    test_mode: "وضع الاختبار · استخدم البطاقة",
    test_card_hint: "· أي تاريخ انتهاء · أي CVC",
    email_label: "البريد الإلكتروني",
    email_ph: "you@escape.com",
    email_help: "برو يتبع هذا البريد على أي جهاز.",
    lifetime: "مدى الحياة",
    lifetime_sub: "دفعة واحدة · الأفضل",
    monthly: "شهري",
    monthly_sub: "ألغِ في أي وقت",
    per_month: "/شهر",
    restore_toggle: "← اشتريت من قبل؟ استعادة",
    restore_hint: "أدخل البريد المستخدم عند الدفع لاستعادة برو على هذا الجهاز.",
    restore_button: "استعادة برو",
    back_purchase: "→ العودة إلى الشراء",
    toast_invalid_email: "يرجى إدخال بريد إلكتروني صالح.",
    toast_purchase_email: "يرجى إدخال بريد الشراء.",
    toast_checkout_failed: "تعذر بدء الدفع. حاول مرة أخرى.",
    toast_no_pro_found: "لا يوجد شراء برو لهذا البريد.",
    toast_pro_unlocked: "تم فتح برو على هذا الجهاز.",
  },
  leaderboard: {
    back: "رجوع",
    header: "قاعة الناجين",
    title_lead: "لوحة",
    title_accent: "الصدارة",
    tab_outdoor: "الخارجي",
    tab_underground: "تحت الأرض",
    tab_daily: "يومي",
    tab_weekly: "أسبوعي",
    watch_ghost: "شاهد الشبح",
    hall_of_champions: "قاعة الأبطال",
    col_rank: "#",
    col_name: "الاسم الرمزي",
    col_time: "الوقت",
    col_score: "النقاط",
    loading: "...جارٍ التحميل",
    empty: "لا توجد سباقات بعد · كن الأول",
  },
  payment: {
    finalizing: "جارٍ الإنهاء",
    confirming: "...جارٍ تأكيد الدفع",
    welcome_pro: "أهلاً بك في برو",
    welcome_desc:
      "كل شيء مفتوح. ثلاثي · تحت الأرض · مراحل لا محدودة · جميع التعزيزات · اللوحة العالمية.",
    start_escaping: "→ ابدأ الهروب",
    not_confirmed: "لم يتم تأكيد الدفع",
    not_confirmed_desc:
      "تعذر تأكيد الدفع. إذا تم خصم المبلغ، استخدم \"استعادة\" من صفحة برو ببريد الشراء.",
    back_menu: "→ العودة إلى القائمة",
    canceled: "تم إلغاء الدفع",
    canceled_desc: "لم يتم أي خصم. يمكنك الترقية إلى برو في أي وقت.",
  },
  common: {
    language: "اللغة",
  },
};

const zh = {
  menu: {
    banner: "霓虹 // 街机 // 2026",
    protocol: "协议：逃脱",
    title1: "停车场",
    title2: "计划",
    title3: "逃脱。",
    tagline:
      "你在步行，他们不是。在停放的汽车间穿梭，闪避无情的猎人，捡起加成，在被压扁之前抵达霓虹绿的出口。两个停车场，一条规则：不要停下。",
    mode: "模式",
    mode_2d: "2D · 俯视",
    mode_3d: "3D · 追逐视角",
    play_outdoor: "开始 · 露天",
    play_underground: "开始 · 地下",
    play_daily: "每日挑战",
    daily_sub: "同一地图 · 全球 · 免费",
    play_rooftop: "开始 · 天台",
    rooftop_sub: "两个出口 · 阵风 · 日落",
    play_highway: "开始 · 高速",
    highway_sub: "6 车道 · 穿越车流 · 夜晚",
    play_snowstorm: "开始 · 暴风雪",
    snowstorm_sub: "湿滑冰面 · 白茫茫 · 两个出口",
    play_tunnels: "开始 · 隧道",
    tunnels_sub: "狭窄迷宫 · 两个出口 · 急转弯",
    play_neon_rain: "开始 · 霓虹雨夜",
    neon_rain_sub: "潮湿霓虹之夜 · 两个出口 · 赛季通行证独占",
    push_on: "推送 · 开启",
    push_off: "推送 · 关闭",
    get_season: "赛季通行证",
    season_badge: "赛季",
    season_monthly_label: "月度",
    achievements: "成就",
    reminder_on: "每日提醒 · 开",
    reminder_off: "每日提醒我",
    daily_at_risk: "连胜有风险 · 今日游玩以保持",
    outdoor_sub: "两个出口 · 中等",
    underground_sub: "一个出口 · 困难",
    pro_tag: "PRO",
    leaderboard: "排行榜",
    how_to_play: "玩法说明",
    local_records: "本地纪录",
    outdoor: "露天",
    underground: "地下",
    power_ups: "加成",
    controls: "操作",
    move: "移动",
    pause: "暂停",
    objective: "目标",
    reach_exit: "到达出口",
    keys_move: "WASD / 方向键",
    key_pause: "ESC",
    footer: "// 保持移动 · 时间即分数",
    upgrade_pro: "升级到 PRO",
    pro_badge: "PRO",
  },
  powerups: {
    shield: "护盾",
    shield_desc: "5 秒对敌车无敌。",
    boost: "加速",
    boost_desc: "4 秒冲刺,快跑!",
    freeze: "冰冻",
    freeze_desc: "3 秒,敌人静止。",
  },
  hud: {
    score: "分数",
    time: "时间",
    stage: "阶段",
    hi: "最高",
    lives: "生命",
    pause: "暂停",
    resume: "继续",
    quit: "退出",
    paused: "已暂停",
    press_esc: "按 ESC 或继续以恢复",
    difficulty_up: "难度提升",
    stage_desc: "更快 · 更多猎人 · +奖励",
    controls_hint: "WASD · 方向键移动 · ESC 暂停 · 到达",
    green_exit: "绿色出口",
  },
  howto: {
    title: "玩法说明",
    subtitle: "逃离停车场,别成为轮下亡魂。",
    move: "移动",
    move_v: "WASD 或方向键",
    pause: "暂停",
    pause_v: "ESC",
    goal: "目标",
    goal_v: "抵达发光的绿色出口",
    avoid: "躲避",
    avoid_v: "红色汽车 — 它们会追你",
    collect: "拾取",
    collect_v: "闪烁的黄色加成",
    footer: "地下模式只有一个出口且猎人更快。到达出口时,剩余时间和生命会计入奖励。",
  },
  gameover: {
    escaped: "你逃脱了。",
    flattened: "被压扁了。",
    level: "关卡",
    time: "时间",
    score: "分数",
    new_high: "新的本地最高分",
    submit_board: "提交到全球榜",
    callsign_ph: "呼号",
    send: "提交",
    unlock: "解锁",
    submitted: "✓ 已提交",
    retry: "重试",
    menu: "菜单",
    board: "排行榜",
    toast_name_missing: "请输入呼号后提交。",
    toast_submitted: "分数已提交到霓虹榜。",
    toast_submit_failed: "无法提交分数,请重试。",
  },
  paywall: {
    tag: "停车场逃脱 · PRO",
    title_lead: "解锁",
    title_accent: "全部。",
    subtitle: "属于 Pro 功能。一次付费,永久畅玩。",
    default_feature: "此功能",
    feature_3d_underground: "3D + 地下",
    feature_3d: "3D 追逐视角",
    feature_underground: "地下车库",
    feature_rooftop: "天台关卡",
    feature_highway: "高速关卡",
    feature_snowstorm: "暴风雪关卡",
    feature_tunnels: "隧道关卡",
    feature_full: "完整体验",
    feature_leaderboard: "全球榜提交",
    bullet_3d: "3D 追逐视角 + 地下车库",
    bullet_stages: "无限关卡(免费版限第 3 关)",
    bullet_powerups: "全部 3 种加成:护盾 · 加速 · 冰冻",
    bullet_leaderboard: "提交分数至全球排行榜",
    test_mode: "测试模式 · 使用卡号",
    test_card_hint: "· 任意未来到期 · 任意 CVC",
    email_label: "电子邮箱",
    email_ph: "you@escape.com",
    email_help: "Pro 会跟随此邮箱在任何设备上生效。",
    lifetime: "终身",
    lifetime_sub: "一次性 · 最超值",
    monthly: "月度",
    monthly_sub: "随时取消",
    per_month: "/月",
    restore_toggle: "已购买?恢复 →",
    restore_hint: "输入结账时使用的邮箱,以在本设备恢复 Pro。",
    restore_button: "恢复 PRO",
    back_purchase: "← 返回购买",
    toast_invalid_email: "请先输入有效邮箱。",
    toast_purchase_email: "请输入购买邮箱。",
    toast_checkout_failed: "无法启动结账,请重试。",
    toast_no_pro_found: "此邮箱未找到 Pro 购买记录。",
    toast_pro_unlocked: "已在本设备解锁 Pro。",
  },
  leaderboard: {
    back: "返回",
    header: "幸存者殿堂",
    title_lead: "排行",
    title_accent: "榜",
    tab_outdoor: "露天",
    tab_underground: "地下",
    tab_daily: "每日",
    tab_weekly: "每周",
    watch_ghost: "观看幽灵",
    hall_of_champions: "冠军殿堂",
    col_rank: "#",
    col_name: "呼号",
    col_time: "时间",
    col_score: "分数",
    loading: "加载中...",
    empty: "尚无记录 · 抢占第一",
  },
  payment: {
    finalizing: "正在完成",
    confirming: "正在确认您的付款…",
    welcome_pro: "欢迎加入 PRO",
    welcome_desc: "已解锁全部内容。3D · 地下 · 无限关卡 · 全部加成 · 全球榜。",
    start_escaping: "开始逃脱 →",
    not_confirmed: "付款未确认",
    not_confirmed_desc: "无法确认扣款。如已被扣款,请用购买邮箱在付费墙点“恢复”。",
    back_menu: "← 返回菜单",
    canceled: "结账已取消",
    canceled_desc: "未产生任何扣款,您可以随时升级到 Pro。",
  },
  common: {
    language: "语言",
  },
};

const ru = {
  menu: {
    banner: "НЕОН // АРКАДА // 2026",
    protocol: "ПРОТОКОЛ: ПОБЕГ",
    title1: "ПАРКОВКА",
    title2: "PLOT",
    title3: "ПОБЕГ.",
    tagline:
      "Вы пешком. Они — нет. Петляйте между припаркованными машинами, уворачивайтесь от неумолимых охотников, собирайте бонусы и добегите до неоново-зелёного выхода, пока вас не задавили. Две парковки. Одно правило: не останавливаться.",
    mode: "РЕЖИМ",
    mode_2d: "2D · СВЕРХУ",
    mode_3d: "3D · КАМЕРА ПРЕСЛЕДОВАНИЯ",
    play_outdoor: "ИГРАТЬ · УЛИЧНАЯ",
    play_underground: "ИГРАТЬ · ПОДЗЕМНАЯ",
    play_daily: "ЕЖЕДНЕВНЫЙ ВЫЗОВ",
    daily_sub: "ОДНА КАРТА · МИР · БЕСПЛАТНО",
    play_rooftop: "ИГРАТЬ · КРЫША",
    rooftop_sub: "ДВА ВЫХОДА · ВЕТЕР · ЗАКАТ",
    play_highway: "ИГРАТЬ · ШОССЕ",
    highway_sub: "6 ПОЛОС · ПЕРЕСЕЧЬ ТРАФИК · НОЧЬ",
    play_snowstorm: "ИГРАТЬ · МЕТЕЛЬ",
    snowstorm_sub: "СКОЛЬЗКИЙ ЛЁД · БЕЛАЯ МГЛА · 2 ВЫХОДА",
    play_tunnels: "ИГРАТЬ · ТУННЕЛИ",
    tunnels_sub: "УЗКИЙ ЛАБИРИНТ · 2 ВЫХОДА · ОСТРЫЕ ПОВОРОТЫ",
    play_neon_rain: "ИГРАТЬ · НЕОНОВЫЙ ДОЖДЬ",
    neon_rain_sub: "МОКРАЯ НЕОН-НОЧЬ · 2 ВЫХОДА · ЭКСКЛЮЗИВ СЕЗОНА",
    push_on: "УВЕДОМЛЕНИЯ · ВКЛ",
    push_off: "УВЕДОМЛЕНИЯ · ВЫКЛ",
    get_season: "СЕЗОННЫЙ ПРОПУСК",
    season_badge: "СЕЗОН",
    season_monthly_label: "МЕСЯЧНЫЙ",
    achievements: "ДОСТИЖЕНИЯ",
    reminder_on: "ЕЖЕДНЕВНОЕ НАПОМИНАНИЕ · ВКЛ",
    reminder_off: "НАПОМИНАТЬ КАЖДЫЙ ДЕНЬ",
    daily_at_risk: "СЕРИЯ ПОД УГРОЗОЙ · ИГРАЙ СЕГОДНЯ",
    outdoor_sub: "ДВА ВЫХОДА · СРЕДНЕ",
    underground_sub: "ОДИН ВЫХОД · СЛОЖНО",
    pro_tag: "PRO",
    leaderboard: "ТАБЛО",
    how_to_play: "КАК ИГРАТЬ",
    local_records: "ЛОКАЛЬНЫЕ РЕКОРДЫ",
    outdoor: "УЛИЧНАЯ",
    underground: "ПОДЗЕМНАЯ",
    power_ups: "БОНУСЫ",
    controls: "УПРАВЛЕНИЕ",
    move: "ДВИЖЕНИЕ",
    pause: "ПАУЗА",
    objective: "ЦЕЛЬ",
    reach_exit: "ДОБЕЖАТЬ ДО ВЫХОДА",
    keys_move: "WASD / СТРЕЛКИ",
    key_pause: "ESC",
    footer: "// НЕ ОСТАНАВЛИВАЙТЕСЬ · ВРЕМЯ = ОЧКИ",
    upgrade_pro: "ПЕРЕЙТИ НА PRO",
    pro_badge: "PRO",
  },
  powerups: {
    shield: "ЩИТ",
    shield_desc: "5 сек неуязвимости к машинам.",
    boost: "УСКОРЕНИЕ",
    boost_desc: "Спринт 4 сек. Беги!",
    freeze: "ЗАМОРОЗКА",
    freeze_desc: "3 сек. Враги замирают.",
  },
  hud: {
    score: "ОЧКИ",
    time: "ВРЕМЯ",
    stage: "ЭТАП",
    hi: "РЕК",
    lives: "ЖИЗНИ",
    pause: "ПАУЗА",
    resume: "ПРОДОЛЖИТЬ",
    quit: "ВЫХОД",
    paused: "ПАУЗА",
    press_esc: "НАЖМИТЕ ESC ИЛИ «ПРОДОЛЖИТЬ»",
    difficulty_up: "СЛОЖНОСТЬ РАСТЁТ",
    stage_desc: "БЫСТРЕЕ · БОЛЬШЕ ОХОТНИКОВ · +БОНУС",
    controls_hint: "WASD · СТРЕЛКИ — движение · ESC — пауза · дойти до",
    green_exit: "ЗЕЛЁНОГО ВЫХОДА",
  },
  howto: {
    title: "КАК ИГРАТЬ",
    subtitle: "Убегайте с парковки. Не станьте лежачим полицейским.",
    move: "ДВИЖЕНИЕ",
    move_v: "WASD или клавиши-стрелки",
    pause: "ПАУЗА",
    pause_v: "ESC",
    goal: "ЦЕЛЬ",
    goal_v: "Добежать до сияющего ЗЕЛЁНОГО выхода",
    avoid: "ИЗБЕГАТЬ",
    avoid_v: "КРАСНЫЕ машины — они гонятся за вами",
    collect: "СОБИРАТЬ",
    collect_v: "Пульсирующие ЖЁЛТЫЕ бонусы",
    footer:
      "В подземном режиме только ОДИН выход и охотники быстрее. Оставшееся время и жизни дают бонус на выходе.",
  },
  gameover: {
    escaped: "ВЫ УБЕЖАЛИ.",
    flattened: "РАЗДАВЛЕН.",
    level: "УРОВЕНЬ",
    time: "ВРЕМЯ",
    score: "ОЧКИ",
    new_high: "НОВЫЙ ЛОКАЛЬНЫЙ РЕКОРД",
    submit_board: "ОТПРАВИТЬ В ГЛОБАЛЬНЫЙ ТОП",
    callsign_ph: "ПОЗЫВНОЙ",
    send: "ОТПРАВИТЬ",
    unlock: "РАЗБЛОКИРОВАТЬ",
    submitted: "✓ ОТПРАВЛЕНО",
    retry: "ПОВТОР",
    menu: "МЕНЮ",
    board: "ТАБЛО",
    toast_name_missing: "Введите позывной для отправки.",
    toast_submitted: "Счёт отправлен в неоновое табло.",
    toast_submit_failed: "Не удалось отправить счёт. Попробуйте ещё.",
  },
  paywall: {
    tag: "PARKING PLOT ESCAPE · PRO",
    title_lead: "Разблокируйте",
    title_accent: "всё.",
    subtitle: "— это Pro-функция. Купите один раз и убегайте навсегда.",
    default_feature: "Эта функция",
    feature_3d_underground: "3D + Подземная",
    feature_3d: "Режим 3D-камеры преследования",
    feature_underground: "Подземный гараж",
    feature_rooftop: "Уровень крыши",
    feature_highway: "Уровень шоссе",
    feature_snowstorm: "Уровень метели",
    feature_tunnels: "Уровень туннелей",
    feature_full: "полный набор",
    feature_leaderboard: "Отправка в глобальное табло",
    bullet_3d: "3D камера преследования + подземный гараж",
    bullet_stages: "Безграничные этапы (в бесплатной версии до 3)",
    bullet_powerups: "Все 3 бонуса: Щит · Ускорение · Заморозка",
    bullet_leaderboard: "Отправка очков в глобальное табло",
    test_mode: "ТЕСТОВЫЙ РЕЖИМ · карта",
    test_card_hint: "· любая будущая дата · любой CVC",
    email_label: "EMAIL",
    email_ph: "you@escape.com",
    email_help: "Pro привязан к этому email на любых устройствах.",
    lifetime: "НАВСЕГДА",
    lifetime_sub: "разовый · лучшая цена",
    monthly: "ЕЖЕМЕСЯЧНО",
    monthly_sub: "отмена в любой момент",
    per_month: "/мес",
    restore_toggle: "УЖЕ ПОКУПАЛИ? ВОССТАНОВИТЬ →",
    restore_hint:
      "Введите email, который вы использовали при оплате, чтобы восстановить Pro.",
    restore_button: "ВОССТАНОВИТЬ PRO",
    back_purchase: "← НАЗАД К ПОКУПКЕ",
    toast_invalid_email: "Введите корректный email.",
    toast_purchase_email: "Введите email, использованный при покупке.",
    toast_checkout_failed: "Не удалось запустить оплату. Попробуйте ещё.",
    toast_no_pro_found: "Для этого email покупок Pro не найдено.",
    toast_pro_unlocked: "Pro активирован на этом устройстве.",
  },
  leaderboard: {
    back: "НАЗАД",
    header: "ЗАЛ ВЫЖИВШИХ",
    title_lead: "ЛИДЕР",
    title_accent: "БОРД",
    tab_outdoor: "УЛИЧНАЯ",
    tab_underground: "ПОДЗЕМНАЯ",
    tab_daily: "ДЕНЬ",
    tab_weekly: "НЕДЕЛЯ",
    watch_ghost: "СМОТРЕТЬ ПРИЗРАКА",
    hall_of_champions: "ЗАЛ ЧЕМПИОНОВ",
    col_rank: "#",
    col_name: "ПОЗЫВНОЙ",
    col_time: "ВРЕМЯ",
    col_score: "ОЧКИ",
    loading: "ЗАГРУЗКА...",
    empty: "ЗАБЕГОВ ЕЩЁ НЕТ · БУДЬТЕ ПЕРВЫМ",
  },
  payment: {
    finalizing: "ЗАВЕРШЕНИЕ",
    confirming: "ПОДТВЕРЖДАЕМ ВАШ ПЛАТЁЖ…",
    welcome_pro: "ДОБРО ПОЖАЛОВАТЬ В PRO",
    welcome_desc:
      "Всё разблокировано. 3D · Подземка · Безграничные этапы · Все бонусы · Глобальное табло.",
    start_escaping: "НАЧАТЬ ПОБЕГ →",
    not_confirmed: "ПЛАТЁЖ НЕ ПОДТВЕРЖДЁН",
    not_confirmed_desc:
      "Не удалось подтвердить списание. Если деньги списаны — используйте «Восстановить» в пейволле по email покупки.",
    back_menu: "← В МЕНЮ",
    canceled: "ОПЛАТА ОТМЕНЕНА",
    canceled_desc: "Списаний не произведено. Вы можете перейти на Pro в любой момент.",
  },
  common: {
    language: "ЯЗЫК",
  },
};

export const TRANSLATIONS = { en, fr, es, ar, zh, ru };
